import React from 'react'
import AttendanceListing from 'components/attendances/AttendanceListing'
import './Attendance.scss'

function Attendances() {
  return <AttendanceListing />
}

export default Attendances
